module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-main"
  }, [_c('div', {
    staticClass: "admin-body"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.dialogTaskInfo.taskInfo,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "价格"
    }
  }, [_c('el-input-number', {
    attrs: {
      "precision": 2,
      "step": 0.01,
      "max": 10000,
      "min": 0.01
    },
    model: {
      value: (_vm.dialogTaskInfo.taskInfo.handPrice),
      callback: function($$v) {
        _vm.$set(_vm.dialogTaskInfo.taskInfo, "handPrice", $$v)
      },
      expression: "dialogTaskInfo.taskInfo.handPrice"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告图"
    }
  }, [(_vm.dialogTaskInfo.taskInfo.adPicUrl) ? _c('el-image', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": _vm.dialogTaskInfo.taskInfo.adPicUrl,
      "fit": "fit",
      "preview-src-list": [_vm.dialogTaskInfo.taskInfo.adPicUrl]
    }
  }) : _vm._e(), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadUrl,
      "headers": _vm.uploadHeaders,
      "on-remove": _vm.handleRemoveByAdPic,
      "limit": 1,
      "on-exceed": _vm.handleExceedByAdPic,
      "on-success": _vm.handleSuccessByAdPic,
      "file-list": _vm.adFileList
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，宽5160，高1200")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.newUpdateTaskClick
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1441cdcb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/hand/dict_mgr.vue
// module id = 1178
// module chunks = 2